import React, { useEffect, useState } from "react";
import {
  getContactSettings,
  saveContactSettings,
  DEFAULT_CONTACT,
} from "../services/settingsService";
import { isSupabaseConfigured } from "../supabase/client";

const ContactAdmin = () => {
  const [data, setData] = useState(DEFAULT_CONTACT);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null); // {type, text}

  useEffect(() => {
    if (!isSupabaseConfigured) { setLoading(false); return; }
    (async () => {
      try {
        setData(await getContactSettings());
      } catch (e) {
        setMsg({ type: "error", text: "Couldn't load settings. Check Supabase config / rules." });
      }
      setLoading(false);
    })();
  }, []);

  const setOffice = (i, k, v) =>
    setData((d) => {
      const offices = d.offices.map((o, idx) => (idx === i ? { ...o, [k]: v } : o));
      return { ...d, offices };
    });

  const addOffice = () =>
    setData((d) => ({
      ...d,
      offices: [...d.offices, { title: "", address: "", email: "", phone: "" }],
    }));

  const removeOffice = (i) =>
    setData((d) => ({ ...d, offices: d.offices.filter((_, idx) => idx !== i) }));

  const setSocial = (k, v) =>
    setData((d) => ({ ...d, social: { ...d.social, [k]: v } }));

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMsg(null);
    try {
      await saveContactSettings(data);
      setMsg({ type: "ok", text: "Saved. Changes are live on the site." });
    } catch (err) {
      setMsg({ type: "error", text: err.message || "Couldn't save." });
    }
    setSaving(false);
  };

  return (
    <>
      <div className="admin-topbar">
        <h2>Contact Info</h2>
      </div>

      <div className="admin-content">
        {!isSupabaseConfigured && (
          <div className="config-warning">
            Add your Supabase keys to <code>.env</code> to enable editing.
          </div>
        )}
        {msg && <div className={`admin-alert ${msg.type}`}>{msg.text}</div>}

        {loading ? (
          <div className="admin-empty">Loading…</div>
        ) : (
          <form onSubmit={handleSave}>
            <div className="admin-panel" style={{ padding: "1.5rem", marginBottom: "1.5rem" }}>
              <div className="admin-panel-head" style={{ padding: 0, border: "none", marginBottom: "1rem" }}>
                <h3>Offices</h3>
                <button type="button" className="btn btn-ghost" onClick={addOffice}>+ Add office</button>
              </div>

              {data.offices.map((o, i) => (
                <div key={i} style={{ borderTop: i ? "1px solid var(--line)" : "none", paddingTop: i ? "1.25rem" : 0, marginTop: i ? "1.25rem" : 0 }}>
                  <div className="admin-row">
                    <div className="admin-field">
                      <label>Office name</label>
                      <input value={o.title} onChange={(e) => setOffice(i, "title", e.target.value)} />
                    </div>
                    <div className="admin-field">
                      <label>Phone</label>
                      <input value={o.phone} onChange={(e) => setOffice(i, "phone", e.target.value)} />
                    </div>
                  </div>
                  <div className="admin-field">
                    <label>Address</label>
                    <input value={o.address} onChange={(e) => setOffice(i, "address", e.target.value)} />
                  </div>
                  <div className="admin-field">
                    <label>Email</label>
                    <input type="email" value={o.email} onChange={(e) => setOffice(i, "email", e.target.value)} />
                  </div>
                  {data.offices.length > 1 && (
                    <button type="button" className="btn btn-danger-text" onClick={() => removeOffice(i)}>
                      Remove this office
                    </button>
                  )}
                </div>
              ))}
            </div>

            <div className="admin-panel" style={{ padding: "1.5rem", marginBottom: "1.5rem" }}>
              <div className="admin-panel-head" style={{ padding: 0, border: "none", marginBottom: "1rem" }}>
                <h3>Careers &amp; Social</h3>
              </div>
              <div className="admin-field">
                <label>Careers email</label>
                <input type="email" value={data.careersEmail || ""} onChange={(e) => setData((d) => ({ ...d, careersEmail: e.target.value }))} />
              </div>
              <div className="admin-row">
                <div className="admin-field">
                  <label>Facebook URL</label>
                  <input value={data.social?.facebook || ""} onChange={(e) => setSocial("facebook", e.target.value)} />
                </div>
                <div className="admin-field">
                  <label>LinkedIn URL</label>
                  <input value={data.social?.linkedin || ""} onChange={(e) => setSocial("linkedin", e.target.value)} />
                </div>
              </div>
            </div>

            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Saving…" : "Save Changes"}
            </button>
          </form>
        )}
      </div>
    </>
  );
};

export default ContactAdmin;
